import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Input, Select, DatePicker, Modal, Tag, Skeleton, Tooltip } from 'antd';
import { FaFileAlt, FaAnchor, FaTimes } from 'react-icons/fa';
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select;




const CpnLichSu = ({loanId}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchData = () => { 

        setLoading(true);

        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/history-payment/${loanId}`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                // Kiểm tra kiểu dữ liệu
                if (Array.isArray(d) || typeof d === 'object') {
                    setData(d);
                } else {
                    console.warn('Dữ liệu không hợp lệ:', d);
                    setData([]); // Thiết lập thành mảng rỗng nếu dữ liệu không hợp lệ
                }
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
                setData([]); // Thiết lập thành mảng rỗng trong trường hợp có lỗi
            }).finally(() =>{
              setLoading(false);
            })
    };

    useEffect(() => {
      fetchData();
    
    }, [])
    
    const columns = [
        { title: '#', dataIndex: 'index', key: 'index', render: (_, __, index) => index + 1 },
        { title: 'Thời gian', dataIndex: 'CREATE_DATE', key: 'CREATE_DATE' },
        { title: 'Giao dịch viên', dataIndex: 'NAME', key: 'NAME' },
        { title: 'Số tiền ghi có', dataIndex: 'PAY_MONEY', key: 'PAY_MONEY', render: (value) => value.toLocaleString('vi-VN') },
        { title: 'Nội dung', dataIndex: 'CONTENT', key: 'CONTENT'},
        { title: 'Ghi chú', dataIndex: 'NOTE', key: 'NOTE'},
    ];


    return (
        <div className="md:p-1">
            {loading ?
                (<Skeleton active />) :

                (<Table
                    className="custom-table"
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.ID}
                    pagination={{
                        total: data.length, // Tổng số dòng dữ liệu
                        showSizeChanger: true, // Hiển thị tùy chọn thay đổi số dòng
                    }}

                    scroll={{ x: 'max-content' }} // Enable horizontal scrolling when content exceeds container width

                />)}

        </div>
    );
};

export default CpnLichSu;
